import { defineMessages } from "react-intl";
export const messages = defineMessages({
    errorMsgCommunity: {
        id: "piLayout.errorMsg.community",
        defaultMessage: "Failed to load communities",
    },
    communitySelectorPlaceholder: {
        id: "piLayout.communitySelector.placeholder",
        defaultMessage: "Filter by Community",
    },
    errorMsgOrganizationsAndCommunities: {
        id: "piLayout.errorMsg.organization",
        defaultMessage: "Failed to load organizations and communities",
    },
    communitySelectorPlaceholderAddMore: {
        id: "piLayout.communitySelector.placeholder",
        defaultMessage: "+ Add Community",
    },
    organizationSelectorPlaceholder: {
        id: "piLayout.organizationSelector.placeholder",
        defaultMessage: "Filter by Organization",
    },
    organizationSelectorPlaceholderAddMore: {
        id: "piLayout.organizationSelector.placeholder",
        defaultMessage: "+ Add Organization",
    },
    piDetailsSummary: {
        id: "app.pi.details.tabs.summary.text",
        defaultMessage: "Prospect Summary",
    },
    piDetailsActivity: {
        id: "app.pi.details.tabs.activity.text",
        defaultMessage: "Prospect Activity",
    },
});
